import { render } from "./JobDescription.vue?vue&type=template&id=543307bf&scoped=true"
import script from "./JobDescription.vue?vue&type=script&lang=js"
export * from "./JobDescription.vue?vue&type=script&lang=js"

import "./JobDescription.vue?vue&type=style&index=0&id=543307bf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543307bf"]])

export default __exports__